// extracted by mini-css-extract-plugin
export default {"card":"styles_card__AP27g","low":"styles_low__xYwR5"};